import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './paymentMethodsActions';

const transformResponseToResources = (response) =>
  response?.data?.map((paymentMethod) => ({
    ...paymentMethod,
    isDeleted: paymentMethod.deleted,
  }));

const mkResourceConfig = (successAction, failureAction) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'paymentMethods',
    resourceBaseUrl: '/paymentmethods',
    transformResponseToResources,
    successAction,
    failureAction,
  });

export function* getPaymentMethodsActionWatcher() {
  const config = mkResourceConfig(actions.getPaymentMethodsSuccess, actions.getPaymentMethodsFailure);
  yield takeLeading(actions.getPaymentMethods, resourceSagaUtils.qcsSyncGetResources, config);
}

export default [getPaymentMethodsActionWatcher];
